import SecureImage from '../consumer/src/assets/images/lock-icon-515151.svg'

import './securePaymentNotice.scss'

const SecurePaymentNotice = () => (
  <div className='secure-payment-notice' data-testid='secure-payment-notice'>
    <div className='img-text-container'>
      <img className='payment-image' src={SecureImage} alt='Secure Payment, Everplans' />
      <div className='secure-image-text'>SECURE TRANSACTION</div>
    </div>
    <div className='secure-section-text'>
      All payments are handled through a secure payment processing company and all credit card details are stored on their secured
      servers. Everplans does not store your credit card details.
    </div>
  </div>
)

export default SecurePaymentNotice
